export const blockIconsTransportationCommuteNew = (
	<span className='material-symbols-outlined'>commute</span>
);
